<template>
<div v-bind:class="this.$store.state.restaurantInfo.skin" class="mainDiv" v-if="!this.$store.state.loader">
  <v-container>
  <main-menu></main-menu>
  <categories-menu></categories-menu>
  <items-menu></items-menu>
  </v-container>
</div>

</template>

<script>
import MainMenu from "@/components/MainMenu";
import CategoriesMenu from "@/components/CategoriesMenu";
import ItemsMenu from "@/components/ItemsMenu";

export default {
  name: "Home",
  components: {
    MainMenu,
    CategoriesMenu,
    ItemsMenu,
  },
  data() {
    return {
      loader: true
    };
  },
  methods: {

  },
  mounted() {
    try {
      // this.$store.dispatch("getUrlParam", { parameter:'restaurantId', defaultvalue: 'generalerror'});
      // this.$store.dispatch("commitLocalData");

      // this.getLocalData();
    } catch (e) {
      console.log(e);
    }
  },
};
</script>

<style>

  .spinAnimation {
    -webkit-animation: spin 2s ease infinite;
    -moz-animation: spin 2s ease infinite;
    animation: spin 2s ease infinite;
  }

  @-moz-keyframes spin {
    100% {
      -moz-transform: rotate(360deg);
    }
  }

  @-webkit-keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

</style>
